import React from 'react';
import { useSession } from '../../contexts/SessionContext';
import ClienteSession from '../sesiones/ClienteSession';
import PresupuestoSession from '../sesiones/PresupuestoSession';
import PedidoSession from '../sesiones/PedidoSession';
import FacturaSession from '../sesiones/FacturaSession';
import ProyectoSession from '../sesiones/ProyectoSession';
import EmailLogSession from '../sesiones/EmailLogSession';

export default function SesionRouter({ children }) {
  const { sesiones, sesionActiva } = useSession();

  if (!sesionActiva) return children;

  const sesion = sesiones.find(s => s.id === sesionActiva);
  if (!sesion) return children;

  switch (sesion.tipo) {
    case 'cliente':     return <ClienteSession sesion={sesion} />;
    case 'presupuesto': return <PresupuestoSession sesion={sesion} />;
    case 'pedido':      return <PedidoSession sesion={sesion} />;
    case 'factura':     return <FacturaSession sesion={sesion} />;
    case 'proyecto':    return <ProyectoSession sesion={sesion} />;
    case 'email':       return <EmailLogSession sesion={sesion} />;
    default:            return children;
  }
}
